import { client } from "@/shared/api/pref-storage";
import { Portfolio } from "@/types/Portfolio";

export const endpoints = {
  GetPortfolios: "/portfolios",
  PostPortfolios: "/portfolios",
};

export const getPortfolios = async () => {
  const response = await client.get(endpoints.GetPortfolios);
  return response.data as Portfolio[];
};

export const createPortfolio = async (portfolioData: Portfolio) => {
  const response = await client.post(endpoints.PostPortfolios, portfolioData);
  return response.data;
};

export const updatePortfolio = async (portfolioData: Portfolio) => {
  const response = await client.patch(
    `${endpoints.GetPortfolios}/${portfolioData.id}`,
    portfolioData
  );
  return response.data;
};

export const deletePortfolio = async (portfolioId: string) => {
  const response = await client.delete(
    `${endpoints.GetPortfolios}/${portfolioId}`
  );
  return response.data;
};

export { usePortfoliosCRUD } from "./usePortfoliosCRUD";
